const SET_STEP = 'REGISTRATION/SET_STEP'
const SET_TOKEN = 'REGISTRATION/SET_TOKEN'
const SET_GOOGLE_TOKEN = 'REGISTRATION/SET_GOOGLE_TOKEN'
const SET_REFERRAL_CODE = 'REGISTRATION/SET_REFERRAL_CODE'
const SET_APPLE_TOKEN = 'REGISTRATION/SET_APPLE_TOKEN'

export {
  SET_STEP,
  SET_TOKEN,
  SET_GOOGLE_TOKEN,
  SET_APPLE_TOKEN,
  SET_REFERRAL_CODE,
}
